import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import PhoneInput from "react-phone-number-input";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import { updateCorporateCustomerContactInfo } from "../../../../redux/slice/customer/customerSlice";
import { states_cities } from "../../../../utils/data/states_cities";

const ContactInformation = ({ data, data1 }) => {
  const [editing, setEditing] = useState(false);
  const [editCustomer, setEditCustomer] = useState();

  const { user_permissions } = useSelector((state) => state?.auth?.user);

  const dispatch = useDispatch();

  const onSubmit = (values) => {
    let payload = { ...values, id: data.id };
    dispatch(updateCorporateCustomerContactInfo(payload));
  };

  const handleClose = () => {
    values.city = data?.city;
    values.email = data?.email;
    values.town = data?.town;
    values.phone_number = data?.phone_number;
    values.business_address = data?.business_address;
    values.state = data?.state;
  };

  const validationScehma = Yup.object().shape({
    city: Yup.string("City must be a string").required("City cannot be blank"),
    email: Yup.string("First Name must be a string").required(
      "Email cannot be blank"
    ),
    town: Yup.string("Town must be a string").required("Town cannot be blank"),
    phone_number: Yup.string("Phone number must be a string").required(
      "Phone number cannot be blank"
    ),
    business_address: Yup.string("Business address must be a string").required(
      "Business address cannot be blank"
    ),
  });
  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
  } = useFormik({
    enableReinitialize: true,
    initialValues: {
      city: data?.city || "",
      email: data?.email || "",
      town: data?.town || "",
      phone_number: data?.phone_number || "",
      business_address: data?.business_address || "",
      state: data?.state || "",
    },
    validationSchema: validationScehma,
    onSubmit,
  });

  useEffect(() => {
    setEditCustomer(
      user_permissions?.some(
        (permission) => permission.name === "edit customer - corporate"
      )
    );
  }, [user_permissions]);

  return (
    <>
      <form
        className='border p-3 rounded-3 mt-4 position-relative'
        onSubmit={handleSubmit}
      >
        <h4 className='fw-semibold text-primary-1 bg-white position-absolute profile-title'>
          Contact Information
        </h4>
        <div className='row'>
          <div className='col-md-12'>
            <div className='row mb-3'>
              <div className='col-md-6'>
                <div className='row'>
                  <div className='col-sm-6 col-md-6'>
                    <label htmlFor='firstName ' className='fw-bold pb-1'>
                      COMPANY EMAIL
                    </label>
                    {!editing ? (
                      <p className=''>{values.email}</p>
                    ) : (
                      <div>
                        <input
                          className='form-control form-control-sm'
                          id='email'
                          value={values.email}
                          type='email'
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        {errors?.email && touched?.email && (
                          <p className='mb-0 text-danger'>
                            {errors?.email + "*"}
                          </p>
                        )}
                      </div>
                    )}
                  </div>
                  <div className='col-sm-6 col-md-6'>
                    <label htmlFor='lastname' className='fw-bold pb-1'>
                      COMPANY PHONE NUMBER
                    </label>
                    {!editing ? (
                      <p>{values.phone_number}</p>
                    ) : (
                      <div>
                        <PhoneInput
                          placeholder='Enter phone number'
                          value={values.phone_number}
                          // onChange={handleChange}
                          onChange={(selectedOption) =>
                            setFieldValue("phone_number", selectedOption)
                          }
                          defaultCountry='NG'
                          name='phone_number'
                          className='form-control form-control-sm custom-phone-input'
                          // dropdownStyle={{height:'70px'}}
                          onBlur={() => {
                            handleBlur({ target: { name: "phone_number" } });
                          }}
                        />
                        {errors?.phone_number && touched?.phone_number && (
                          <p className='mb-0 text-danger'>
                            {errors?.phone_number + "*"}
                          </p>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className='col-md-6'>
                <div className='row'>
                  <div className='col-sm-6 col-md-6'>
                    <label htmlFor='middlename' className='fw-bold pb-1'>
                      CITY
                    </label>
                    {!editing ? (
                      <p className='text-capitalize'>{values.city}</p>
                    ) : (
                      <select
                        disabled={values?.state?.length === 0 ? true : false}
                        name='city'
                        type='city'
                        id='city'
                        value={values.city}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className={`form-select ${
                          errors.city && touched.city ? "is-invalid" : ""
                        }`}
                      >
                        <option value=''>-- select an option --</option>
                        {states_cities
                          ?.filter((f) => f.name == values?.state)[0]
                          ?.cities?.map((city, index) => (
                            <option key={index} value={city}>
                              {" "}
                              {city}{" "}
                            </option>
                          ))}
                      </select>
                    )}
                    {errors.city && touched.city && (
                      <span className='invalid-feedback'> {errors.city} </span>
                    )}
                  </div>
                  <div className='col-sm-6 col-md-6'>
                    <label htmlFor='middlename' className='fw-bold pb-1'>
                      TOWN
                    </label>
                    {!editing ? (
                      <p>{values.town}</p>
                    ) : (
                      <div>
                        <input
                          className='form-control form-control-sm'
                          type={"text"}
                          name='town'
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values?.town}
                        />
                        {errors?.town && touched?.town && (
                          <p className='mb-0 text-danger'>
                            {errors?.town + "*"}
                          </p>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className='row mb-2'>
              <div className=' col-md-6'>
                <label htmlFor='middlename' className='fw-bold pb-1'>
                  BUSINESS ADDRESS
                </label>
                {!editing ? (
                  <p>{values.business_address}</p>
                ) : (
                  <div>
                    <textarea
                      className='form-control form-control-sm'
                      type={"text"}
                      name='business_address'
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values?.business_address}
                    ></textarea>
                    {errors?.business_address && touched?.business_address && (
                      <p className='mb-0 text-danger'>
                        {errors?.business_address + "*"}
                      </p>
                    )}
                  </div>
                )}
              </div>
              <div className='col-md-6'>
                <label
                  htmlFor='inputEmail4'
                  className='form-label d-flex align-baseline'
                >
                  <span>State</span>
                </label>
                {!editing ? (
                  <p>{values.state}</p>
                ) : (
                  <select
                    name='state'
                    type='state'
                    id='state'
                    value={values.state}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className={`form-control ${
                      errors.state && touched.state ? "is-invalid" : ""
                    }`}
                  >
                    <option value=''>-- select an option --</option>
                    {states_cities?.map(({ name }, index) => (
                      <option key={index} value={name}>
                        {name}
                      </option>
                    ))}
                  </select>
                )}
                {errors.state && touched.state && (
                  <span className='invalid-feedback'> {errors.state} </span>
                )}
              </div>
            </div>
          </div>
        </div>
        {editCustomer && data1?.status !== "3" && (
          <div className='row mt-1'>
            <div className='col-md-12'>
              <div className='d-flex justify-content-end'>
                <div>
                  <button
                    type='button'
                    className={`btn btn-${
                      editing ? "warning" : "info"
                    } btn-sm px-4 text-white`}
                    onClick={() => {
                      setEditing(editing ? false : true);
                      handleClose();
                      // setError({...{}, })
                    }}
                  >
                    {editing ? "Close" : "Edit"}
                  </button>
                  {editing && (
                    <button
                      className='btn btn-success ms-2 btn-sm px-4'
                      type='submit'
                    >
                      Save
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </form>
    </>
  );
};

export default ContactInformation;
